import { Injectable } from '@angular/core';
import { SelectItem } from 'primeng/api';

@Injectable()
export class TableService {
  getUniqueFilterOptions(types: any[]): SelectItem[] {
    let distinctTypesSet: Set<string | number>;
    let distinctTypes: (string | number)[];

    types = types.filter((x) => x);

    if (types.every((x) => typeof x === 'number')) {
      distinctTypesSet = new Set(types as number[]);
      distinctTypes = Array.from(distinctTypesSet);
      distinctTypes.sort((a: number, b: number) => a - b);
    } else {
      distinctTypesSet = new Set(types as string[]);
      distinctTypes = Array.from(distinctTypesSet);
      distinctTypes.sort();
    }

    const result = distinctTypes.map((x) => ({
      value: x,
      label: x?.toString(),
    }));

    return result;
  }
}
